import React, { useCallback, useRef, useState } from "react";
import ToastContainer from "../../commons/Toast";
import ToastContext from "./ToastContext";

interface ToastProviderProps {}

const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const [toasts, setToasts] = useState<any[]>([]);

  const id = useRef<number>(0);

  const addToast = useCallback(
    (content) => {
      const newToast = { id: id.current++, content };
      setToasts((t) => [...t, newToast]);
    },
    [setToasts]
  );

  const removeToast = useCallback(
    (id) => {
      setToasts((t) => t.filter((_t) => _t.id !== id));
    },
    [setToasts]
  );
  return (
    <ToastContext.Provider value={{ addToast, removeToast }}>
      {children}
      <ToastContainer toasts={toasts} />
    </ToastContext.Provider>
  );
};

export default ToastProvider;
